import { VALTYPES } from '../../../../data/interfaces';
import { CONFIGPARAMTYPES, createConfigParamBoolean, createConfigParamLabelSpace } from '../../helpers/configParams';
import { TpChartManifest } from '../interfaces';
import { UpsetPlot } from './UpsetPlot';

export const manifestUpsetPlot: TpChartManifest = {
  id: 'UpsetPlot',
  name: 'Upset plot',
  description: `For a **multi-categorical property** (i.e. a property where each value can be a list of categorical states), displays the frequency of occurrence of all possible combinations of states.`,
  component: UpsetPlot,
  canvasBased: true,
  groups: [
    { groupId: 'sets', groupName: 'Sets' },
    { groupId: 'advanced', groupName: 'Advanced' },
  ],
  aspects: [
    {
      id: 'sets',
      name: 'Sets data',
      description: 'Property containing the multi-valued categorical states (the "sets") to map the intersections for.',
      groupId: 'sets',
      required: true,
      quality: 1,
      dataType: VALTYPES.MULTICAT,
    },
    {
      id: 'summedValue',
      name: 'Summed value',
      groupId: 'sets',
      description:
        'Optional numerical property. If set, bars represent the total of this property instead of occurrence counts. Missing values are treated as 0. Negative values will trigger a console warning and the accumulated total will be capped at 0.',
      required: false,
      quality: 0.25,
      dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
    },
  ],
  configParams: [
    {
      id: 'displayYAxis',
      name: 'Display Y-axis',
      groupId: 'advanced',
      description: 'If set, displays the numerical Y-axis and horizontal grid lines for the intersection bars.',
      paramType: createConfigParamBoolean(false),
    },
    {
      id: 'setsLabelSpace',
      name: 'Set label space',
      groupId: 'sets',
      description:
        'Scaling factor that determines how much space in the chart is used by the names of the different states.',
      paramType: createConfigParamLabelSpace(),
    },
    {
      id: 'usedValues',
      name: 'Included set values',
      groupId: 'sets',
      hidden: true,
      description:
        'Optionally lists the names of the states that should be included in the plot, separated by `;`. Other states will not be included.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.String },
    },
  ],
  examples: [
    {
      id: 'upsetplot_1',
    },
  ],
};
